module.exports = __webpack_public_path__ + "img/vertical_6_1_3009.7d4578d3.png";